import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  Label,
  CardTitle,
  CardSubtitle,
  Spinner,
} from "reactstrap";
import { AvForm, } from "availity-reactstrap-validation";

// Redux
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Select from "react-select"
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { postSubmitForm } from "../../../helpers/forms_helper";
import showNotification from "../../../helpers/show_notification";
import { checkOutOfStock } from "../../../helpers/po_helper";
import { convertToLowestUnit, GetUpdatedDelivered, formatUnitsForReport } from "../../../helpers/units";
import { useRef } from "react";
import moment from "moment";
import EnterQuantityModal from "../../EnterQuantityModal";

const ProductsDirectTransfer = (props) => {
  const [cartProducts, setCartProducts] = useState([]);
  const storeId = localStorage.getItem("store_id")
  const storeType = localStorage.getItem("store_type")

  const [selectedStore, setSelectedStore] = useState("");
  const [selectUnitModal, setSelectUnitModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState("")


  useEffect(() => {
    if (selectedProduct) {
      loadAllBranchProductBatches();
    }
  }, [selectedProduct]);

  useEffect(() => {
    if (props.allStores[0]?.type === "CENTRAL STORE" && storeType === "Sub Store") {
      setSelectedStore(() => props.allStores[0])
    }
  }, [props.allStores])


  const refSelectedBatch = useRef(null);
  const refSelectedProduct = useRef(null);
  const [allBatches, setAllBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState();
  const loadAllBranchProductBatches = async () => {
    let url = process.env.REACT_APP_BASEURL + "storeproductinventories/get_by_product_id";
    let response = await postSubmitForm(url, {
      product_id: selectedProduct._id,
    });
    if (response.status === 1) {
      const result = response.data
      const batchOptions = result.map(batch => ({
        ...batch,
        label: `${batch.batch} - Expiry: ${new Date(batch.expiry_date).toLocaleDateString()}`,
        value: batch._id
      }));

      setAllBatches(batchOptions);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const handleDeleteRow = (batch) => {
    setCartProducts((prevCartProducts) => {
      const updatedCartProducts = prevCartProducts.filter((item) => item.batch !== batch);
      return updatedCartProducts;
    });
  };


  const columns_cartProducts = [
    {
      dataField: "category",
      text: props.t("Category"),
    },
    {
      dataField: "section",
      text: props.t("Section"),
    },
    {
      dataField: "name",
      text: props.t("Name"),
      sort: true,
    },
    {
      dataField: "batch",
      text: props.t("Batch"),
    },
    {
      dataField: "expiry_date",
      text: props.t("Expiry Date"),
      formatter: (cell, row) => {
               return row.expiry_date ? moment(row.expiry_date).format("DD/MM/YYYY") : '';
      },
    },
    {
      text: props.t("Transfer Quantity"),
      dataField: "quantity",
      sort: false,
      editable: false,
      formatter: (cell, row) => {
        return (
          <>
            {formatUnitsForReport(row.quantity)}
          </>
        )
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      footer: false,
    },

    {
      dataField: "",
      editable: false,
      text: "Remove",
      formatter: (cell, row) => {
        return (
          <span className="d-flex justify-content-center text-danger">
            <i
              className="bx bxs-trash font-size-20"
              title="Click to Remove"
              style={{ cursor: "pointer" }}
              onClick={() => {
                handleDeleteRow(row.batch)
              }}
            ></i>
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      sort: false,
      footer: false,
    },
  ];

  const handleAddUnits = async (quantity) => {
    var new_array_products = JSON.parse(JSON.stringify(cartProducts));
    const existing_product = new_array_products.filter(function (item) {
      return item.batch === selectedBatch.batch;
    });

    if (existing_product.length > 0) {
      showNotification(
        props.t("This product batch is already added."),
        props.t("Error")
      );
    } else if (selectedBatch) {
      let totalEntered = convertToLowestUnit(selectedProduct?.unit_levels, quantity);
      let totalAvailable = convertToLowestUnit(selectedProduct?.unit_levels, selectedBatch.quantity)
      if (totalEntered > totalAvailable) {
        showNotification("Can not enter more than available in batch", "Warning");
        return
      }
      let convertedQuantity = GetUpdatedDelivered(quantity, selectedProduct?.unit_levels)
      let product_to_add = {};
      product_to_add.product_id = selectedProduct?._id;
      product_to_add.batch = selectedBatch.batch;
      product_to_add.name = selectedProduct?.name;
      product_to_add.section = selectedProduct?.section;
      product_to_add.category = selectedProduct?.category;
      product_to_add.brand = selectedProduct?.brand;
      product_to_add.quantity = convertedQuantity.map(({ unit, value }) => ({ unit, value: parseFloat(value) })) || null;
      product_to_add.unit_levels = selectedProduct?.unit_levels;
      product_to_add.expiry_date = selectedBatch.expiry_date;
      product_to_add.cost_price = selectedBatch.cost_price;
      product_to_add.selling_price = selectedProduct.selling_price;
      setCartProducts([...cartProducts, product_to_add]);
      setSelectUnitModal(false);
      setSelectedProduct("");
      setSelectedBatch();
      // refSelectedProduct.current.select.clearValue();
    } else {
      showNotification(props.t("Select a product batch first."), props.t("Error"));
    }
  };

  const [isDisabled, setIsDisabled] = useState(false)
  const handleValidSubmit = async (e, v) => {
    try {
      setIsDisabled(true)
      const object = {
        transferredProducts: cartProducts,
        remarks: v.remarks,
        transferToStoreId: selectedStore && selectedStore._id,
        transferFromStoreId: storeId,
      };
      // console.log(object,"Payload");
      // return
      let url = process.env.REACT_APP_BASEURL + "storesproductstransfer/direct_transfer";
      let response = await postSubmitForm(url, object);

      if (response.status === 1) {
        setIsDisabled(false)
        props.onStoreSelect(selectedStore)
        setCartProducts([]);
        setSelectedProduct("");
        setSelectedBatch()
        showNotification(response.message, "Success");
      } else if (response.status === 2) {
        setIsDisabled(false)
        showNotification(response.message, "Warning");
      } else {
        setIsDisabled(false)
        showNotification(response.message, "Error");
      }
    } catch (error) {
      setIsDisabled(false)
      showNotification(error, "Error");
    }
  };

  function handleCloseModal() {
    setSelectUnitModal(false);
    setSelectedBatch()
  }

  function handleSelectBatch(e) {
    setSelectedBatch(e)
    setSelectUnitModal(!selectUnitModal)
  }

  function storeName() {
    let name = localStorage.getItem("store_name")
    let role = localStorage.getItem("role")
    if (role === "Storekeeper") {
      name = "CENTRAL KITCHEN STORE"
    }
    return name
  }


  return (
    <React.Fragment>
      <Row>

        <Col lg={12}>
          <Card>
            <CardBody >
              <CardTitle>{props.t("Transfer Products")}</CardTitle>
              <CardSubtitle>{props.t("Enter the following details to initiate transfer of products")}</CardSubtitle>
              <AvForm>
                <Row className="mt-2">

                  <Col lg={4}>
                    <Label>{props.t("To")}</Label>
                    <Select
                      options={props.allStores}
                      placeholder={props.t("None")}
                      onChange={(se) => { setSelectedStore(se); setSelectedProduct("");setCartProducts([]); props.onStoreSelect(se) }}
                      value={selectedStore}
                      className="basic-single"
                      classNamePrefix="select"
                    />
                  </Col>

                  {selectedStore && (
                    <Col lg={4} >
                      <Label>{props.t("Product")}</Label>
                      <Select
                        // ref={refSelectedProduct}
                        options={props.allProducts}
                        placeholder={props.t("None")}
                        onChange={(se) => { setSelectedProduct(se) }}
                        classNamePrefix="select2-selection"
                        value={selectedProduct}
                        className="basic-single"

                      />
                    </Col>
                  )}

                  {selectedProduct && (
                    <>
                      <Col lg={2}>
                        <br />
                        <Label>{`${storeName()} Avl.`}</Label>
                        <br />
                        <Label>
                          {formatUnitsForReport(selectedProduct?.store_available, selectedProduct?.unit_levels)}
                        </Label>
                      </Col>
                      <Col lg={2}>
                        <br />
                        <Label>Threshold Quantity</Label>
                        <br />
                        <Label>
                          {selectedProduct?.threshold +
                            " " +
                            selectedProduct?.unit_for_threshold}
                        </Label>
                      </Col>
                    </>
                  )}



                  {selectedProduct && checkOutOfStock(selectedProduct?.store_available) ? (
                    <Col lg={4}>
                      <p class="text-muted mb-2">&nbsp;</p>
                      <div class="alert alert-danger fade show text-center" role="alert">
                        {props.t("This item is out of stock.")}
                      </div>
                    </Col>
                  )
                    : (
                      selectedProduct && (

                        <Col lg={4}>
                          <br />
                          <Label>{props.t("Batch")}</Label>
                          <Select
                            ref={refSelectedBatch}
                            value={selectedBatch && selectedBatch}
                            key={selectedBatch}
                            onChange={(e) => { handleSelectBatch(e) }}
                            options={allBatches && allBatches}
                            classNamePrefix="select2-selection"
                            required
                          />
                        </Col>

                      )

                    )
                  }
                </Row>
              </AvForm>
              <hr />

              {cartProducts.length > 0 && (
                <Row className="mt-5">
                  <Col lg={12}>


                    <ToolkitProvider
                      bootstrap4
                      keyField="product_id"
                      data={cartProducts}
                      columns={columns_cartProducts}
                      noDataIndication={props.t("No data to display.")}
                      search
                    >
                      {(props) => (
                        <div>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            {...props.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                    <AvForm onValidSubmit={handleValidSubmit}>
                      <Row>
                        {/* <Col lg={6}>
                        <AvField
                          name="remarks"
                          value={remarks}
                          onChange={(e) => {
                            setRemarks(e.target.value);
                          }}
                          label={props.t("Remarks")}
                          placeholder={props.t("Enter Remarks")}
                          type="textarea"
                        />
                      </Col> */}
                        <Col lg={12}>
                          <hr />
                          <FormGroup className="mb-0 text-left">
                            <div>
                              <Button
                                type="submit"
                                color="primary"
                                style={{ width: '100px' }} 
                                disabled={isDisabled}
                                className="mr-1"
                              >
                            {isDisabled ? <Spinner size="sm" /> : props.t("Submit")} 
                              </Button>
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                    </AvForm>

                  </Col>
                </Row>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>




      {/* Add Quantity modal  */}
      <EnterQuantityModal
        isOpen={selectUnitModal}
        toggle={handleCloseModal}
        onSubmit={handleAddUnits}
        item={selectedProduct}
        checkLimitFor={"batch"}
        selectedBatch={selectedBatch}
      />
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => { };
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(ProductsDirectTransfer))
);

